const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./portfolio.less')
const PortfolioHeader = require('./portfolio_header')
const PortfolioItem = require('./portfolio_item')
const Escape = require('component/escape')
const log = require('log').create('portfolio') // eslint-disable-line

/*

MAYBE TODO
- create standalone portfolio overlay
- figure out nav/layer interaction
- update url to /user/portfolio when portfolio overlay is showing
- create page/portfolio wrapper

*/


function sortByOrder(a, b) {
    return a.order - b.order
}

class Portfolio extends React.Component {

    constructor(props) {
        super(props)
        this.onPopState = this.onPopState.bind(this)
    }

    componentDidMount() {
        if (this.props.close) {
            history.pushState({}, null)
            window.addEventListener('popstate', this.onPopState)
        }
    }

    componentWillUnmount() {
        if (this.props.close) {
            window.removeEventListener('popstate', this.onPopState)
        }
    }

    onPopState(e) {
        const { close } = this.props
        if (close) close()
    }

    render() {
        const { user, close } = this.props

        const items = user.portfolio

        items.sort(sortByOrder)

        return (
            <div className={styles.scope}>
                {close && <Escape onEscape={close} />}
                {/*
                    rendering two copies of header:
                    the first one is hidden, preserving layout
                    the second one is class .fixed, so it pins to top
                */}
                <PortfolioHeader user={user} close={close} hidden={true} />
                <PortfolioHeader user={user} close={close} />
                <div className="structure">
                    <div className="portfolio-items">
                        {items.map((item, i) => <PortfolioItem key={i} item={item} />)}
                    </div>
                </div>
            </div>
        )
    }
}

Portfolio.propTypes = {
    user: PropTypes.shape({
        portfolio: PropTypes.array,
    }).isRequired,
    close: PropTypes.func,
}

// module.exports = Portfolio
module.exports = withStyles(styles)(Portfolio)
